import React, { Component } from 'react';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { Field, withShouldComponentUpdate } from '../Forms';

const modules = {
  toolbar: {
    container: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline','strike', 'blockquote'],
      [{ 'color': [] }, { 'background': [] }],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      ['link', 'image'],
      ['clean']
    ],
    handlers: {
      image: function imageHandler() {
        const range = this.quill.getSelection();
        const value = prompt('What is the image URL');
        this.quill.insertEmbed(range.index, 'image', value, 'user');
      }
    }
  },
}

class Textarea extends Component {
  render() {
    const { name, defaultValue, validate, required } = this.props;
    return (
      <Field
        name={name}
        defaultValue={defaultValue}
        validate={validate}
        required={required}
        component={({ value, trigger })=> {
          return (
            <ReactQuill
              modules={modules}
              value={value}
              onChange={(val)=> {
                trigger([
                  { type: 'onChange', value: val },
                  { type: 'onValidate' },
                  { type: 'onTouched' },
                  { type: 'onDirty' },
                ]);
              }}
            />
          )
        }}/>
    )
  }
}

export default withShouldComponentUpdate(Textarea);



// WEBPACK FOOTER //
// ./src/app/components/Forms/fields/RichText.js